export default __webpack_public_path__ + "static/media/element-navigation.fd66fcaa.svg";